<!-- Paid -->

<!-- Closed Order -->
<div class="checkout-section" *ngIf="orderDetails.isClosed">
  <div class="paid-list">
    <div>
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          <div class="font-14 fontRegular grey-color">
            {{'placeOrder.Closed by' | translate }}
          </div>
          <div class="name-with-image small">
              <div class="image-circle">
                  <span class="font-14 fontMedium"
                    *ngIf="!orderDetails.closedBy.profilePic">
                      {{orderDetails.closedBy.name | shortName}}
                  </span>
                  <img *ngIf="orderDetails.closedBy.profilePic"
                      [src]="orderDetails.closedBy.profilePic"
                      (error)="orderDetails.closedBy.profilePic = ''">
              </div>
              <div class="name">
                  <h5 class="font-16 fontMedium">{{orderDetails.closedBy.name}}</h5>
              </div>
          </div>
        </div>
        <div>
          <div class="status-badge">{{'placeOrder.Closed' | translate}}</div>
        </div>
      </div>
      <hr>
      <div class="d-flex mt-4">
          <div class="font-14 fontRegular grey-color">{{'placeOrder.Closed Date/Time' | translate }}</div>
          <div class="font-14 fontMedium ml-auto">{{orderDetails.closeDate | date:'d MMM, y - h:mm a'}}</div>
      </div>
    </div>
  </div>
</div>
<!-- End Closed Order -->

<div class="checkout-section">
  <div class="label grey-color" *ngIf="orderDetails.paymentDetails?.length">
    <ng-container *ngIf="orderDetails.paymentDetails.length <= 1">{{'orders.Paid' | translate}}</ng-container>
    <ng-container *ngIf="orderDetails.paymentDetails.length > 1">
      {{'checkout.Paid in split receipts' | translate: {no: orderDetails.paymentDetails.length} }}</ng-container>
  </div>

  <div class="text-center mb-4" *ngIf="orderDetails.canPrintAll">
    <button mat-button color="primary"
      [disabled]="printRecipt"
      [class.loading]="printRecipt"
      (click)="printRecipt = true"
      class="text-uppercase">
        <img src="./assets/images/icons/checkout/print-receipt-ic-black.svg" alt="">
        <span>{{'checkout.Print receipt' | translate}}</span>
    </button>
  </div>

  <div class="paid-list" *ngIf="orderDetails.paymentDetails?.length">

    <div *ngFor="let item of orderDetails.paymentDetails; index as i">
      <div class="d-flex align-items-center">
        <div>
          <span class="font-20 fontRegular">
              {{currency.currencyCode}}
              <span class="fontSemiBold">{{item.priceAmount}}</span>
          </span>
          <div>
            <ng-container *ngIf="item.paymentOption == 'Cash'">
              <span class="grey-color fontMedium">{{'checkout.Paid Cash' | translate}}</span>
              <span class="fontMedium ml-2"> ({{currency.currencyCode}} {{item.paidPrice}})</span>
            </ng-container>
            <ng-container *ngIf="item.paymentOption == 'CreditCard' || item.paymentOption == 'Mada'">
              <span class="grey-color fontMedium">{{'checkout.Paid by Card' | translate}}</span>
              <span class="fontMedium"> {{'checkout.Ends with' | translate: {no: item.cardLastNumbers} }}</span>
            </ng-container>
            <ng-container *ngIf="item.paymentOption != 'Cash' && item.paymentOption != 'CreditCard' && item.paymentOption != 'Mada'">
              <span class="grey-color fontMedium">{{'orders.Paid by' | translate}} {{item.paymentOptionName}}</span>
              <span class="fontMedium ml-2"> ({{currency.currencyCode}} {{item.paidPrice}})</span>
            </ng-container>
          </div>

        </div>

        <div class="ml-auto" *ngIf="item.canPrint">
          <div class="d-flex align-items-center">
            <mat-spinner diameter="15" *ngIf="printCheckOutId == item.checkOutId"></mat-spinner>
            <button mat-icon-button class="ml-2" [disabled]="printRecipt"
              [matTooltip]="'servers.Print' | translate"
              (click)="printCheckOutId = item.checkOutId; printRecipt = true">
              <img src="./assets/images/icons/checkout/print-receipt-ic.svg" alt="">
            </button>
          </div>
        </div>
      </div>

      <!-- Other Payment Method -->
      <div *ngIf="item.otherPaymentMethod?.otherPaymentMethodsId">
        <hr>
        <div class="grey-color fontMedium">
          {{'orders.Paid by' | translate}}
          <!-- {{'checkout.Other Payment options' | translate}} -->
          {{item.otherPaymentMethod.otherPaymentMethodsName}}
        </div>
        <div class="fontMedium text-wrap">
          {{item.otherPaymentMethod.otherPaymentMethodComment}}</div>
      </div>
      <!-- End Other Payment Method -->

      <hr>
      <div class="d-flex align-items-center">
        <div>
          <ng-container *ngIf="item.remainAmount && !item.tipsValue">
            <span class="font-20 fontRegular">
              {{currency.currencyCode}}
              <span class="fontSemiBold">{{item.remainAmount}}</span>
            </span>
            <div>
              <span class="grey-color">{{'checkout.Remaining (Change)' | translate}}</span>
            </div>
          </ng-container>

          <ng-container *ngIf="item.tipsValue">
            <span class="font-20 fontRegular">
                {{currency.currencyCode}}
                <span class="fontSemiBold">{{item.tipsValue}}</span>
            </span>
            <div>
              <span class="grey-color">{{'checkout.Added Tip' | translate}}</span>
            </div>
          </ng-container>

          <div class="grey-color" *ngIf="!item.tipsValue && !item.remainAmount">{{'checkout.No Tip Added' | translate}}</div>
        </div>

        <div class="ml-auto" *ngIf="item.canAddTip && showActions">
          <button mat-button color="primary"
            (click)="activePayment = item"
            class="text-uppercase">{{'checkout.Add a tip' | translate}}</button>
        </div>
      </div>

      <!-- Paid items -->
      <ng-container *ngIf="item.reservationOrderSelectedItems?.length">
        <hr>
        <div class="paid-items">
          <div class="grey-color font-14">{{'checkout.Paid Items' | translate}}</div>
          <div class="list">
            <div class="d-flex align-items-center"
              *ngFor="let x of item.reservationOrderSelectedItems">
              <div class="d-flex align-items-center">
                <div class="img-container"><img [src]="x.itemPic" alt=""></div>
                <div>
                  <span class="font-13">{{x.itemName}} ({{x.sizeName}})</span>
                  <span class="grey-color font-13 ml-2">x{{x.quantity}}</span>
                </div>
              </div>
              <div class="ml-auto">
                <span class="font-13 fontLight">
                  {{currency.currencyCode}}
                  <span class="fontMedium">{{x.itemPrice}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <hr>

      <div class="name-with-image small">
        <div class="image-circle">
          <span class="font-14 fontMedium" *ngIf="!item.profilePic">
            {{item.handledBy | shortName }}
          </span>
          <img *ngIf="item.profilePic" [src]="item.profilePic" (error)="item.profilePic = ''">
        </div>
        <div class="name">
          <h5 class="font-12 fontRegular grey-color">
            {{'orders.Handled by' | translate }}
          </h5>
          <div class="font-16 fontMedium">
            {{item.handledBy}}
            <span class="font-14 fontRegular grey-color" *ngIf="item.ishandledByYou">
              ({{'general.You' | translate}})
            </span>
            <span class="font-16" *ngIf="item.ishandledByQrCode">({{'general.Paid via QR' | translate}})</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- END Paid -->

<app-num-keypad
  *ngIf="activePayment"
  [title]="'checkout.Add Tip' | translate"
  [value]="activePayment.remainAmount"
  [currency]="currency"
  (close)="addTipManual($event)"
></app-num-keypad>

<div hidden *ngIf="printRecipt">
  <app-receipt
    [orderId]="orderDetails.orderId"
    [checkOutId]="printCheckOutId"
    (isReady)="printReady()"
    ></app-receipt>
</div>
